/**
 * articles.ts — SINGLE SOURCE OF TRUTH
 *
 * This file derives all article listing data (title, slug, category, excerpt,
 * image, date, readTime, views) directly from the article-details files.
 *
 * To update an article's title, image, excerpt or date across the ENTIRE site,
 * edit only the relevant file in src/mocks/article-details/. Changes propagate
 * automatically to every card, listing, and related-articles section.
 */

import { articleDetails } from './article-details';

export interface Article {
  id: number;
  title: string;
  slug: string;
  category: string;
  categoryColor: string;
  excerpt: string;
  image: string;
  views: string;
  readTime: string;
  date: string;
}

export const articles: Article[] = Object.values(articleDetails)
  .sort((a, b) => a.id - b.id)
  .map(detail => ({
    id: detail.id,
    title: detail.title,
    slug: detail.slug,
    category: detail.category,
    categoryColor: detail.categoryColor,
    excerpt: detail.excerpt,
    image: detail.featuredImage,
    views: detail.views,
    readTime: detail.readTime,
    date: detail.publishDate,
  }));

/** First 3 articles — used by FeaturedArticles and similar components */
export const featuredArticles: Article[] = articles.slice(0, 3);

/** All articles up to 8 — used by LatestArticles and similar components */
export const latestArticles: Article[] = articles.slice(0, 8);
